// URL รูปที่ API ส่งมาให้ <img> ใช้ — บางครั้งเป็น path สัมพัทธ์ของ API เอง ("/api/v0/BlobProxy/Image?src=…")
//
// ทำไมต้องมีไฟล์นี้: storage ของ UAT ปิด firewall จาก internet (Deny + private endpoint) browser ยิงไป
// blob URL ตรง ๆ จะได้ 403 ฝั่ง API จึงคืน displayUrl เป็น path ของ proxy แทน (ดู BlobProxyBal.cs)
// SPA ไม่ได้อยู่ host เดียวกับ API เสมอไป (เช่น .env.uat-api ชี้ ask-ai-adm-api-uat) path สัมพัทธ์จึงต้อง
// ต่อท้าย VITE_APP_API ก่อน ไม่งั้น browser จะไปขอจาก host ของหน้าเว็บแทน

/**
 * ต่อ path ที่ขึ้นต้นด้วย "/" เข้ากับ base ของ API — URL เต็ม (https://…, data:, blob:) และค่าว่างคืนเดิม
 * "//host/…" (protocol-relative) ไม่ใช่ path ของเรา ก็คืนเดิมเช่นกัน
 */
export function resolveApiAssetUrl(url, apiBase = import.meta.env.VITE_APP_API) {
  if (typeof url !== 'string' || !url.startsWith('/') || url.startsWith('//')) return url;
  const base = String(apiBase || '/').replace(/\/+$/, '');
  return base + url;
}

/** รูปของ banner: displayUrl (อาจเป็น proxy) ก่อน ถ้าไม่มีก็ imageUrl เดิม */
export function bannerImageSrc(banner, apiBase) {
  if (!banner) return '';
  return resolveApiAssetUrl(banner.displayUrl || banner.imageUrl || '', apiBase);
}
